import { render } from "./ManagementServerPeerTab.vue?vue&type=template&id=6173db61"
import script from "./ManagementServerPeerTab.vue?vue&type=script&lang=js"
export * from "./ManagementServerPeerTab.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__